module.exports = __webpack_public_path__ + "static/media/scholar.e6242d3e.png";